import { createSelector } from 'reselect';

const selectGlobalNicCodes = (state: any) => state.globalNicCodes;


export const selectGlobalNicCodesCurrentItem = createSelector([selectGlobalNicCodes], (globalNicCodes) => globalNicCodes.current);

export const selectGlobalNicCodesListItems = createSelector([selectGlobalNicCodes], (globalNicCodes) => globalNicCodes.list);

export const selectGlobalNicCodesItemById = (itemId: any) =>
    createSelector(selectGlobalNicCodesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectGlobalNicCodesQueryItems = createSelector([selectGlobalNicCodes], (globalNicCodes) => globalNicCodes.query);

export const selectGlobalNicCodesCreatedItem = createSelector([selectGlobalNicCodes], (globalNicCodes) => globalNicCodes.create);

export const selectGlobalNicCodesUpdatedItem = createSelector([selectGlobalNicCodes], (globalNicCodes) => globalNicCodes.update);

export const selectGlobalNicCodesReadItem = createSelector([selectGlobalNicCodes], (globalNicCodes) => globalNicCodes.read);

export const selectGlobalNicCodesDeletedItem = createSelector([selectGlobalNicCodes], (globalNicCodes) => globalNicCodes.delete);

export const selectGlobalNicCodesSearchedItems = createSelector([selectGlobalNicCodes], (globalNicCodes) => globalNicCodes.search);

export const selectGlobalNicCodesItemsCount = createSelector([selectGlobalNicCodes], (globalNicCodes) => globalNicCodes.count);

export const selectGlobalNicCodesItemsFilter = createSelector([selectGlobalNicCodes], (globalNicCodes) => globalNicCodes.filter);